'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');let

SharedWidthSourceDirective=class SharedWidthSourceDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}
get textBindings(){
return['name'];
}
get controller(){
return SharedWidthSourceDirectiveController;
}};let


SharedWidthSourceDirectiveController=class SharedWidthSourceDirectiveController extends BaseResizableDirectiveController{
static get $inject(){
return['$rootScope','$scope','$element','$window'];
}

constructor($rootScope,$scope,$element,$window){
super($scope,$element,$window);

this._$rootScope=$rootScope;

this._initializeSharedWidths();
this._mySharedWidth=null;

$scope.$on('$destroy',()=>{
this._removeMySharedWidth();
});
}

_initializeSharedWidths(){
if(!_.exists(this._$rootScope.sharedWidths)){
this._$rootScope.sharedWidths={};
}
}

set _mySharedWidth(value){
this._$rootScope.sharedWidths[this.name]=value;
}

get _mySharedWidth(){
return this._$rootScope.sharedWidths[this.name];
}

_removeMySharedWidth(){
delete this._$rootScope.sharedWidths[this.name];
}

_onDimensionsChanged(newDimensions,oldDimensions){
if(_.exists(newDimensions)&&newDimensions.width!==this._mySharedWidth){
this._mySharedWidth=newDimensions.width;
}
}};


module.exports=SharedWidthSourceDirective;
//# sourceMappingURL=sharedWidthSourceDirective.js.map
